import React, { useContext } from 'react';
import { OpenViduContext } from './OpenViduContext';


export const useOpenVidu = () => {
  const context = useContext(OpenViduContext);
  if (!context) {
    throw new Error('useOpenVidu must be used within OpenViduProvider');
  }
  return context;
};

